import React, { useRef } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { colors } from '@/styles';

/**
 * VideoPlaybackRateButtons component
 *
 * @param {import('./VideoPlaybackRateButtons').VideoPlaybackRateButtonsProps} props
 */
export const VideoPlaybackRateButtons = ({ className, player, playbackRates }) => {
  /** @type {React.MutableRefObject<HTMLDivElement>} */
  const playbackButtonsRef = useRef(null);

  const handlePlaybackRate = (event) => {
    playbackButtonsRef.current
      .querySelectorAll('[data-rate]')
      .forEach((el) => el.classList.remove('playback-active'));
    event.target.classList.add('playback-active');

    const playbackRate = event.target.dataset.rate;
    const video = player.tech(true);
    video.setPlaybackRate(playbackRate);
  };

  return (
    <div
      className={`${className} playback-buttons-inactive playback-buttons`}
      ref={playbackButtonsRef}
    >
      {playbackRates.map((rate, index) => (
        <button
          data-rate={rate}
          type="button"
          className={index === 0 ? 'playback-active' : ''}
          onClick={handlePlaybackRate}
          key={rate}
        >
          {rate}x
        </button>
      ))}
    </div>
  );
};

VideoPlaybackRateButtons.propTypes = {
  /** Emotion base style */
  className: PropTypes.string.isRequired,
  /** The vjs player */
  player: PropTypes.shape().isRequired,
  /** The playback rates from player options */
  playbackRates: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number])).isRequired,
};

const styledVideoPlaybackRateButtons = styled(VideoPlaybackRateButtons)`
  position: absolute;
  top: 11px;
  left: 11px;
  transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  z-index: 100;

  button {
    border: none;
    margin-right: 8px;
    background: transparent;
    color: ${colors.white};
    font-size: 12px;
    height: 21px;
    width: 35px;
    font-weight: 500;
    padding: 0;
  }

  .playback-active {
    color: ${colors.almostBlack};
    background: ${colors.white};
    border-radius: 4px;
  }
`;

export default styledVideoPlaybackRateButtons;
